import { Component, inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { GameId } from 'src/app/model/game/game-id';
import { safeModalDismiss } from 'src/app/shared/utils/modal.utils';
import { SolitaireCheatSheet } from './data/cheat-sheet-solitaire';
import { BlocksCheatSheet } from './data/cheat-sheet-blocks';
import { BlackjackCheatSheet } from './data/cheat-sheet-blackjack';
import { TwentyOneCheatSheet } from './data/cheat-sheet-twentyone';
import { assertNever } from 'src/games/common/helper';
import { SlotsCheatSheet } from './data/cheat-sheet-slots';
import { PlinkoCheatSheet } from './data/cheat-sheet-plinko';
import { MarblesCheatSheet } from './data/cheat-sheet-marbles';
import { ThemePipe } from '../../core/pipes/theme.pipe';
import { NgClass, NgStyle } from '@angular/common';
import { NavButtonComponent } from '../../ui/buttons/nav-button/nav-button.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { Rule } from './data/rule';
import { VideoPokerCheatSheet } from './data/cheat-sheet-videopoker';
import { HiLoCheatSheet } from './data/cheat-sheet-hilo';

@Component({
  selector: 'app-cheat-sheet',
  templateUrl: './cheat-sheet.component.html',
  styleUrls: ['./cheat-sheet.component.scss'],
  imports: [TranslocoDirective, NavButtonComponent, NgClass, NgStyle, ThemePipe],
})
export class CheatSheetComponent implements OnInit {
  @Input({ required: true }) gameId!: GameId;

  private modalController = inject(ModalController);

  themeService = inject(ThemeService);
  cheatSheets = SolitaireCheatSheet.allCheatSheets;
  drawerConfig = this.themeService.payDrawerConfig();

  readonly titleStyles: [string, string][] = [
    ['text-color', 'drawer-cheat-sheet-title'],
    ['type', 'drawer-cheat-sheet-title'],
  ];

  readonly headerStyles: [string, string][] = [
    ['text-color', 'drawer-cheat-sheet-header'],
    ['type', 'drawer-cheat-sheet-header'],
  ];

  readonly bodyStyles: [string, string][] = [
    ['text-color', 'drawer-cheat-sheet-body'],
    ['type', 'drawer-cheat-sheet-body'],
  ];

  ngOnInit(): void {
    this.cheatSheets = CheatSheetComponent.getCheatSheets(this.gameId);
  }

  public async onCloseClick(): Promise<void> {
    await safeModalDismiss(this.modalController);
  }

  private static getCheatSheets(gameId: GameId): Rule[] {
    switch (gameId) {
      case GameId.Blackjack:
        return BlackjackCheatSheet.allCheatSheets;
      case GameId.Blocks:
        return BlocksCheatSheet.allCheatSheets;
      case GameId.Solitaire:
        return SolitaireCheatSheet.allCheatSheets;
      case GameId.TwentyOne:
        return TwentyOneCheatSheet.allCheatSheets;
      case GameId.Slots:
        return SlotsCheatSheet.allCheatSheets;
      case GameId.Plinko:
        return PlinkoCheatSheet.allCheatSheets;
      case GameId.Marbles:
        return MarblesCheatSheet.allCheatSheets;
      case GameId.VideoPoker:
        return VideoPokerCheatSheet.allCheatSheets;
      case GameId.HiLo:
        return HiLoCheatSheet.allCheatSheets;
      default:
        assertNever(gameId, 'Invalid gameId');
    }
  }
}
